import { useLingui } from '@lingui/react/macro';
import { styled } from '@linaria/react';
import { Dialog } from 'app-ui/primitives/surfaces';
import { MOBILE_VIEWPORT } from 'app-ui/theme';

import { CommandMenuContent } from '@/command-menu/components/CommandMenuContent';
import { COMMAND_MENU_WIDTH } from '@/command-menu/constants/CommandMenuWidth';
import { useCloseCommandMenu } from '@/command-menu/hooks/useCloseCommandMenu';
import { isCommandMenuOpenState } from '@/command-menu/states/isCommandMenuOpenState';
import { HotkeyLayerEffect } from '@/ui/utilities/hotkey/effect-components/HotkeyLayerEffect';
import { useAtomStateValue } from '@/ui/utilities/state/jotai/hooks/useAtomStateValue';

// The attribute selector outranks the dialog's default size, and the menu
// sits high on the screen so the list can grow downwards without moving.
const StyledPopup = styled(Dialog.Popup)`
  &[data-size] {
    align-self: flex-start;
    inline-size: ${COMMAND_MENU_WIDTH}px;
    margin-top: 12vh;
    max-block-size: 70vh;
    overflow: hidden;
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    &[data-size] {
      margin-top: 0;
    }
  }
`;

export const CommandMenu = () => {
  const { t } = useLingui();
  const isCommandMenuOpen = useAtomStateValue(isCommandMenuOpenState);
  const { closeCommandMenu } = useCloseCommandMenu();

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      closeCommandMenu();
    }
  };

  return (
    <Dialog.Root open={isCommandMenuOpen} onOpenChange={handleOpenChange}>
      <StyledPopup aria-label={t`Command menu`}>
        <HotkeyLayerEffect layer="overlay" />
        <CommandMenuContent />
      </StyledPopup>
    </Dialog.Root>
  );
};
